import styled, { keyframes } from "styled-components"

const grow = keyframes`
  from { transform: scale(0); }
  to { transform: scale(1); }
`

export const Hero = styled.section`
  padding: 3rem 0 3.5rem;
  @media (min-width: 992px) {
    padding: 5rem 0 5.5rem;
  }
`

export const Inner = styled.div`
  display: grid;
  gap: 2.5rem;
  align-items: center;
  @media (min-width: 992px) {
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
    gap: 4rem;
  }
`

export const Copy = styled.div``

export const Overline = styled.p`
  margin: 0 0 1.25rem;
  font-size: 1rem;
  font-weight: 500;
  color: var(--muted);
`

/* The two corner marks come from the wordmark: medien⌐kram¬ */
export const Frame = styled.div`
  position: relative;
  display: inline-block;
  margin: 0 0 1.5rem -0.5rem;
  padding: 1rem 1.5rem 1rem 0.75rem;
  @media (min-width: 992px) {
    margin-left: -1.5rem;
    padding: 1.4rem 2rem 1.4rem 1.5rem;
  }
  h1 {
    margin: 0;
    max-width: 19ch;
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 32px;
    height: 32px;
    border: 3px solid var(--navy);
    animation: ${grow} 500ms cubic-bezier(0.2, 0.7, 0.2, 1) 150ms both;
    @media (min-width: 992px) {
      width: 48px;
      height: 48px;
      border-width: 4px;
    }
  }
  &::before {
    top: 0;
    right: 0;
    border-left: 0;
    border-bottom: 0;
    transform-origin: top right;
  }
  &::after {
    bottom: 0;
    left: 0;
    border-right: 0;
    border-top: 0;
    transform-origin: bottom left;
  }
`

export const Subline = styled.p`
  max-width: 52ch;
  margin-bottom: 1.75rem;
  font-size: 1.1875rem;
  line-height: 1.55;
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.75rem;
  > a {
    flex: 1 1 auto;
  }
  @media (min-width: 420px) {
    > a {
      flex: 0 0 auto;
    }
  }
`

export const Trust = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: var(--muted);
`

export const Availability = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--green);
  > span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--green);
    box-shadow: 0 0 0 4px rgba(15, 107, 79, 0.15);
  }
`

export const Brands = styled.p`
  margin: 0;
  max-width: 60ch;
  strong {
    color: var(--text);
  }
`

export const Portrait = styled.div`
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  @media (min-width: 992px) {
    max-width: 460px;
    margin: 0;
  }
`
